import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query'

import { UnauthorizedError } from 'lib/apiClient'
import { AuthService, AuthType } from 'lib/auth'

import { QueryKey } from './consts'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
  queryCache: new QueryCache({
    onError: (err, { queryKey }) => {
      if (err instanceof UnauthorizedError && queryKey[0] !== QueryKey.whoami) {
        AuthService.signInRedirect(AuthType.Reauthenticate)
      }
    },
  }),
  mutationCache: new MutationCache({
    onError: err => {
      if (err instanceof UnauthorizedError) {
        AuthService.signInRedirect(AuthType.Reauthenticate)
      }
    },
  }),
})
